<template>
  <div class="small-top col">
    <label>{{label}}</label>
    <textarea class="textarea" v-bind:value="value"
          v-on:input="$emit('input', $event.target.value)"
          v-on="listeners"
          v-bind="attrs"/>
  </div>
</template>

<script>
export default {
  props: ["label", "value"],
  computed: {
    attrs() {
      return this.$attrs;
    },
    listeners() {
      const { input, ...listeners } = this.$listeners;
      return listeners;
    },
  },

}
</script>

<style>

</style>
